


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import formatNumber from '@/shared/filters/format-number';
import pricingServices from '@/services/pricing-services';
import commonService from '@/services/common-services';

@Component
export default class PricingDetail extends Vue {
    private listWeightPrice: any[] = [];
    private listVolumePrice: any[] = [];

    get configuration() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].configuration;
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    get productTypes()  {
        if (this.configuration && this.configuration.ProductTypes) {
            return JSON.parse(this.configuration.ProductTypes);
        }
        return [];
    }

    private async created() {
        await this.getConfiguration();
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        await this.loadData();
    }

    private async loadData() {
        const result = await pricingServices.getDetail();
        if (result && result.data && result.data.status === 200) {
            this.listWeightPrice = result.data.data.list_weight_price;
            this.listVolumePrice = result.data.data.list_volume_price;
        }
    }

    private async getConfiguration() {
        const result = await commonService.configuration();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CONFIGURATION', result.data.data);
        }
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private getProductTypeName(value: number) {
        if (this.productTypes.length === 0) {
            return '';
        }

        const type = this.productTypes.find((p) => p.value === value);
        return type ? type.name : '';
    }

    private getStoreName(value: number) {
        if (!this.warehouse || this.warehouse.length === 0) {
            return '';
        }

        const type = this.warehouse.find((p) => p.ID === value);
        return type ? type.Name : '';
    }
}
